module.exports = __webpack_public_path__ + "img/3.d2041988.png";